import { render, staticRenderFns } from "./RunBatchJobButton.vue?vue&type=template&id=71238334&"
import script from "./RunBatchJobButton.vue?vue&type=script&lang=js&"
export * from "./RunBatchJobButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports